import React from 'react';
import styles from './styles.module.scss';

const Panel = ({
    children,
}) => (
    <div className={styles.Panel}>
        { children }
    </div>
);

export default Panel;
